import { IUser } from '../interfaces/user/IUser';

export const getUserInitials = (user: IUser) => {
  const name = user?.displayName;
  if (!name) return '';

  const nameParts = name.trim().split(/\s+/);

  const initials = nameParts
    .filter((part) => part.length > 0)
    .map((part) => part[0].toUpperCase());

  return initials.slice(0, 2).join('');
};
